export function createEmptyFinanceTempRow() {
  return {
    username: '',
    name: '',
    department: '',
    deptL1: '',
    deptL2: '',
    deptL3: '',
    auditRole: 'finance-temp-viewer',
    templateId: '',
  };
}

export function buildUpdatedFinanceTempRows(rows, index, key, value) {
  const nextRows = [...rows];
  const row = { ...nextRows[index] };
  if (key === 'deptL1') {
    row.deptL1 = value;
    row.deptL2 = '';
    row.deptL3 = '';
    row.department = value || '';
  } else if (key === 'deptL2') {
    row.deptL2 = value;
    row.deptL3 = '';
    row.department = value || row.deptL1 || '';
  } else if (key === 'deptL3') {
    row.deptL3 = value;
    row.department = value || row.deptL2 || row.deptL1 || '';
  } else {
    row[key] = value;
  }
  nextRows[index] = row;
  return nextRows;
}

export function buildNextTempAuditDeptPath(currentPath, key, value) {
  const current = currentPath || { deptL1: '', deptL2: '', deptL3: '' };
  const nextPath = { ...current };
  if (key === 'deptL1') {
    nextPath.deptL1 = value;
    nextPath.deptL2 = '';
    nextPath.deptL3 = '';
  } else if (key === 'deptL2') {
    nextPath.deptL2 = value;
    nextPath.deptL3 = '';
  } else {
    nextPath.deptL3 = value;
  }
  return nextPath;
}

export function resolveFinalDeptFromPath(path) {
  return path?.deptL3 || path?.deptL2 || path?.deptL1 || '';
}

export function normalizeDeptSelectionList(list) {
  return (list || [])
    .map((value) => String(value || '').trim())
    .filter(Boolean);
}

export function toggleDeptSelection(list, deptName) {
  const next = new Set(normalizeDeptSelectionList(list));
  if (next.has(deptName)) next.delete(deptName);
  else next.add(deptName);
  return Array.from(next);
}

export function addDeptSelections(list, additions) {
  const next = new Set(normalizeDeptSelectionList(list));
  (additions || []).forEach((name) => next.add(name));
  return Array.from(next);
}

export function buildDefaultTempUserConfig(auditGroup) {
  return {
    riskVisibleTabs: ['matrix', 'control', 'event-map', 'list'],
    riskEditableDepartments: auditGroup ? [auditGroup] : [],
    internalVisibleDraftGroups: ['资金管理', '销售与收款'],
    internalVisibleModes: ['draft'],
    internalDraftEvalPermission: 'edit',
  };
}

export function buildFilteredDeptOptions(allOrgDeptOptions, deptKeyword) {
  const keyword = String(deptKeyword || '').trim().toLowerCase();
  return (allOrgDeptOptions || []).filter((name) => !keyword || String(name).toLowerCase().includes(keyword));
}

export function buildSelectedDeptList(list) {
  return normalizeDeptSelectionList(list);
}

export function toggleStringSelection(list, value) {
  const next = new Set((list || []).map((item) => String(item || '').trim()).filter(Boolean));
  if (next.has(value)) next.delete(value);
  else next.add(value);
  return Array.from(next);
}

export function buildTempUserCardViewState({
  user,
  tempConfigMap,
  tempAuditDeptPathMap,
  tempAuditGroupMap,
  deptSearchMap,
  allOrgDeptOptions,
}) {
  const cfg = tempConfigMap?.[user?.id] || buildDefaultTempUserConfig(user?.auditGroup);
  const auditPath = tempAuditDeptPathMap?.[user?.id] || { deptL1: '', deptL2: '', deptL3: '' };
  const filteredDeptOptions = buildFilteredDeptOptions(allOrgDeptOptions, deptSearchMap?.[user?.id]);
  const selectedDeptList = buildSelectedDeptList(cfg?.riskEditableDepartments);
  const displayAuditGroup = tempAuditGroupMap?.[user?.id] || user?.auditGroup || '未分配部门';
  return {
    cfg,
    auditPath,
    filteredDeptOptions,
    selectedDeptList,
    displayAuditGroup,
  };
}
